import React                        from 'react';
import Flux                         from '../flux/Flux';
import ContestGrid                  from './ContestGrid';
import PropTypes                    from 'prop-types';
import {getUrlWithinsertedGetParam} from "../utils/CommonUtils";
import LogoLoader                   from './Loader/LogoLoader';

const CONTAINER_ID = 'contests__container';
const CONTENT_ID   = 'contests__content';

class ContestGridWrapper extends React.Component {

	constructor(props) {
		super(props);
		this.container       = this.props.containerId ? document.getElementById(this.props.containerId) : null;
		this.isReloading     = false;
		this.itemsPerPage    = this.props.contestArea !== Flux.Constants.ContestSubTypes.TOP_10 ? 50 : 10;
		this.lastOffset      = window.pageYOffset;

		this.onBeforeImageClick             = this.onBeforeImageClick.bind(this);
		this.onContestGridChange            = this.onContestGridChange.bind(this);
		this.onContestShouldOpenMediaChange = this.onContestShouldOpenMediaChange.bind(this);
		this.onScroll                       = this.onScroll.bind(this);

		const contestData     = Flux.Contest.getContestGridConfig(props.contestId, props.contestArea);
		const shouldOpenMedia = Flux.Contest.getShouldOpenMedia();
		const openMediaConfig = Flux.Contest.getShouldOpenMediaConfig();
		let currentPage       = props.initialPage;

		if (shouldOpenMedia && openMediaConfig) {
			currentPage = openMediaConfig.currentPage ? openMediaConfig.currentPage : currentPage;
		} else if (contestData && contestData.contestsGridConfig && contestData.contestsGridConfig.contestGridItems) {
			const page = Math.ceil(contestData.contestsGridConfig.contestGridItems.length / this.itemsPerPage);
			if (page > currentPage) {
				currentPage = page;
			}
		}


		// state
		this.state = {
			contestsGridConfig: contestData ? contestData.contestsGridConfig : null,
			currentPage:        currentPage,
			showToTopButton:    false,
			showLoader:         false,
		};

		if (!this.props.isMobile && this.state.currentPage !== 1) {
			Flux.Browser.historyReplaceState(window.history.state || {}, '', window.location.href.split('?')[0] + getUrlWithinsertedGetParam('page', this.state.currentPage));
		}
	}

	componentDidMount() {
		Flux.Contest.addContestGridChangeListener(this.onContestGridChange);
		Flux.Contest.addContestShouldOpenMediaChangeListener(this.onContestShouldOpenMediaChange);

		if (!this.state.contestsGridConfig || this.props.isMobile) {
			Flux.Contest.loadContestGridItems(this.props.contestId, this.props.contestArea, this.itemsPerPage * this.state.currentPage, 0, false, this.props.actorName);
		}

		if (this.props.isMobile) {
			Flux.VXMobile.addContainerScrollListener(CONTAINER_ID, CONTENT_ID, this.onScroll);
		} else {
			window.addEventListener('scroll', this.onScroll);
		}
	}

	componentWillUnmount() {
		Flux.Contest.removeContestGridChangeListener(this.onContestGridChange);
		Flux.Contest.removeContestShouldOpenMediaChangeListener(this.onContestShouldOpenMediaChange);

		if (this.props.isMobile) {
			Flux.VXMobile.removeContainerScrollListener(CONTAINER_ID, CONTENT_ID, this.onScroll);
		} else {
			window.removeEventListener('scroll', this.onScroll);
		}
	}

	onBeforeImageClick(clb) {
		if (!this.isReloading && (this.state.contestsGridConfig === null || this.state.contestsGridConfig.elementsCount > this.state.currentPage * this.itemsPerPage)) {
			Flux.Contest.loadContestGridItems(this.props.contestId, this.props.contestArea, this.state.contestsGridConfig.elementsCount, this.state.currentPage * this.itemsPerPage, true, this.props.actorName);
			this.setState({showLoader: true});

			const afterChangeFn = () => {
				this.setState({showLoader: false});
				Flux.Contest.removeContestGridChangeListener(afterChangeFn);
				clb();
			};
			Flux.Contest.addContestGridChangeListener(afterChangeFn);
		} else {
			clb();
		}
	}

	onContestGridChange(contestId, contestArea) {
		if (this.props.contestId === contestId && contestArea === this.props.contestArea) {
			const contestData = Flux.Contest.getContestGridConfig(contestId, contestArea);

			this.setState({
				contestsGridConfig: contestData.contestsGridConfig,
				currentPage:        Math.ceil(contestData.contestsGridConfig.contestGridItems.length / this.itemsPerPage),
			});

			if (typeof this.props.parentCallback === 'function' && this.props.contestArea === 'voted') {
				this.props.parentCallback(contestData.contestsGridConfig);
			}

			if (!this.props.isMobile) {
				Flux.Browser.historyReplaceState(window.history.state || {}, '', window.location.href.split('?')[0] + getUrlWithinsertedGetParam('page', this.state.currentPage));
			}
			this.isReloading = false;
		}
	}

	onContestShouldOpenMediaChange(shouldOpen, config) {
		if (config && config.currentPage) {
			this.setState({
				currentPage: config.currentPage,
			});
			if (!this.props.isMobile) {
				Flux.Browser.historyReplaceState(window.history.state || {}, '', window.location.href.split('?')[0] + getUrlWithinsertedGetParam('page', this.state.currentPage));
			}
			Flux.Contest.removeContestShouldOpenMediaChangeListener(this.onContestShouldOpenMediaChange);
		}
	}

	onScroll(pos, prevPos, containerHeight, contentHeight) {
		if (this.props.isMobile) {
			const scrollThreshold = contentHeight - containerHeight * 1.75; // trigger load under 75% of container height

			if (pos > scrollThreshold && this.props.contestArea !== Flux.Constants.ContestSubTypes.TOP_10 && !this.isReloading && (this.state.contestsGridConfig === null || this.state.contestsGridConfig.elementsCount > this.state.currentPage * this.itemsPerPage)) {
				Flux.Contest.loadContestGridItems(this.props.contestId, this.props.contestArea, this.itemsPerPage, this.state.currentPage * this.itemsPerPage, true, this.props.actorName);
				this.isReloading     = true;
			}

			if (pos > 200 && !this.state.showToTopButton) {
				this.setState(
					{
						showToTopButton: true,
					}
				);
			} else if (pos < 200 && this.state.showToTopButton) {
				this.setState(
					{
						showToTopButton: false,
					}
				);
			}
		} else {
			if (this.container) {
				const bottomScrollPos = window.pageYOffset + document.documentElement.clientHeight;
				// offset from container to top of page + container height - 250
				let smallestOffsetHeightElement = this.container;

				const contestGrids = Array.from(document.getElementsByClassName('contests__imagerow'));
				for (const elm of contestGrids) {
					smallestOffsetHeightElement = smallestOffsetHeightElement.offsetHeight < elm.offsetHeight ? smallestOffsetHeightElement : elm;
				}
				const triggerPos      = smallestOffsetHeightElement.getBoundingClientRect().top + window.pageYOffset + smallestOffsetHeightElement.offsetHeight - 2000;

				// trigger reload if bottomScrollPos below triggerPos, no reload was triggered until now and the user scrolled down
				if (bottomScrollPos >= triggerPos && !this.isReloading && window.pageYOffset > this.lastOffset && (this.state.contestsGridConfig === null || this.state.contestsGridConfig.elementsCount > this.state.currentPage * this.itemsPerPage)) {
					Flux.Contest.loadContestGridItems(this.props.contestId, this.props.contestArea, this.itemsPerPage, this.state.currentPage * this.itemsPerPage, true, this.props.actorName);
					this.isReloading     = true;
				}

				this.lastOffset = window.pageYOffset;
			}
		}
	}

	scrollToTop() {
		document.getElementById(CONTAINER_ID).scrollTop = 0;
	}

	render() {
		return <div className="contests__container">
			{(this.props.isMobile && this.state.contestsGridConfig === null) || (this.state.showLoader) &&
			<div className="contest__nocontent-container h-text-align-center">
				<LogoLoader pulse />
			</div>}
			{this.state.contestsGridConfig && <ContestGrid
				isMobile={this.props.isMobile}
				currentPage={this.state.currentPage}
				contestsGridConfig={this.state.contestsGridConfig}
				containerId={CONTAINER_ID}
				onBeforeImageClick={this.onBeforeImageClick}
				startMediaIndex={this.props.startMediaIndex}
				contestArea={this.props.contestArea}
			                                  />}
			{this.state.showToTopButton && <button onClick={this.scrollToTop}
			                                       className={"btn--back-to-top -mobile -icon-arrow-up-full -click-material -fixed -show-material h-disp-block"}
			                               />}
		</div>;
	}
}

ContestGridWrapper.propTypes = {
	containerId:     PropTypes.string,
	contestArea:     PropTypes.string.isRequired,
	contestId:       PropTypes.number.isRequired,
	initialPage:     PropTypes.number,
	isMobile:        PropTypes.bool,
	startMediaIndex: PropTypes.number,
	actorName:       PropTypes.string,
	parentCallback:  PropTypes.object,
};

ContestGridWrapper.defaultProps = {
	initialPage: 1,
	isMobile:    true,
	actorName:   '',
};

export default ContestGridWrapper;
